module.exports = __webpack_public_path__ + "static/media/FontAwesome5_Solid.b70cea03.ttf";